// React
import React from "react";
import { useHistory, useParams, Link } from "react-router-dom";
import MetaTags from "react-meta-tags";

// Material-UI
import Avatar from "@material-ui/core/Avatar";
import { makeStyles, withStyles } from "@material-ui/core/styles";

import Hidden from "@material-ui/core/Hidden";
import Box from "@material-ui/core/Box";

import {
  Container,
  Button,
  Fab,
  Typography,
  Grid,
  Tooltip,
  Chip,
} from "@material-ui/core";

import SvgIcon from "@material-ui/core/SvgIcon";

import IconButton from "@material-ui/core/IconButton";
import Popover from "@material-ui/core/Popover";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MenuIcon from "@material-ui/core/MenuItem";

import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";

import TextField from "@material-ui/core/TextField";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

//Material-UI Icons
import EditIcon from "@material-ui/icons/CreateOutlined";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import DeleteIcon from "@material-ui/icons/DeleteForever";
import DraftsIcon from "@material-ui/icons/Drafts";
import SendIcon from "@material-ui/icons/Send";
import LinkIcon from "@material-ui/icons/Link";
import FaceIcon from "@material-ui/icons/Face";
import TagIcon from "@material-ui/icons/LocalOffer";
import AddIcon from "@material-ui/icons/Add";
import VisibilityIcon from "@material-ui/icons/Visibility";
import UnlistedIcon from "@material-ui/icons/VisibilityOff";
import WebIcon from "@material-ui/icons/Web";
import Badge from "@material-ui/core/Badge";

// Massless
import * as Services from "../massless/Services";

import { useAuth } from "../context/AuthContext";
import { useSpace } from "../context/SpaceContext";
import { useSnackbar } from "../context/SnackbarContext";
import { useCommands } from "../context/CommandBarContext";
import { BreadcrumbGenerator } from "../components/BreadcrumbGenerator";
import { SpaceViewer } from "../components/SpaceViewer/SpaceViewer";
// import { SpaceInspector } from "../components/SpaceViewer/SpaceInspector";
import { SideAlert } from "../components/SideAlert";
import { sAnalyticsTrack, trackUser } from "../massless/AnalyticsClient";

import SpaceGrid from "../components/SpaceGrid/SpaceGrid";

import { useKeys } from "../context/KeysContext";

const useStyles = makeStyles((theme) => ({
  appBody: {
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    width: "100%",

    backgroundColor: "#F0F2F5",
    [theme.breakpoints.down("md")]: {
      height: "50vh",
      borderRadius: 0,
      margin: "0",
      overflow: "visible",
      boxShadow: "none",
    },
    [theme.breakpoints.up("md")]: {
      height: "calc(100vh - 40px)",
      borderRadius: "40px",
      margin: "20px 20px 20px 0",
      overflow: "hidden",
      boxShadow: "inset 0px 0px 0px 1px #D9DFF2",
    },
  },
  bodyContainer: {
    maxWidth: "none",
    padding: "0",
    flexGrow: "1",
  },
  pageDetails: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "100%",
    [theme.breakpoints.down("md")]: {
      padding: "16px 8px 0 8px",
      textAlign: "center",
    },
    [theme.breakpoints.up("md")]: {
      padding: "8px 0 8px 16px",
      maxHeight: "65px",
      textAlign: "left",
    },
  },
  pageTitle: {
    fontSize: "1.5rem",
    fontWeight: 300,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    maxWidth: "100%",
  },
  pageDescriptionDesktop: {
    fontSize: "0.75rem",
    // position: "absolute",
    // bottom: 5,
    maxWidth: "100%",
    textAlign: "center",
  },
  projectDetailButtons: {
    width: "47.5%",
    margin: "20px 0 20px 5%",
    borderRadius: "100px",
  },
  spaceTopUI: {
    position: "absolute",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      width: "100% !important",
      padding: "10px",
      zIndex: "2",
      position: "fixed",
    },
    [theme.breakpoints.up("sm")]: {
      width: "calc(100% - 60px)",
      padding: "20px 40px 20px 20px",
    },
  },
  spaceDetails: {
    position: "absolute",

    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    [theme.breakpoints.up("sm")]: {
      width: "30%",
      top: 0,
      left: "35%",
      margin: "23px 0 0",
    },
  },
  tagDialog: {
    [theme.breakpoints.up("sm")]: {
      width: "500px",
    },
    marginBottom: 0,
    padding: "8px",
  },
  shareDialog: {
    maxWidth: "536px",
  },
  chipList: {
    display: "flex",
    minHeight: "36px",
    padding: "0 16px",
    flexWrap: "wrap",
    listStyle: "none",
    margin: 0,
  },
  privateChipList: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    listStyle: "none",
    padding: "0",
  },
  chip: {
    margin: "10px 2px 2px",
  },
  userAvatar: {
    display: "flex",
    alignSelf: "center",
  },
  emailField: {
    display: "flex",
    alignItems: "flex-end",
    marginLeft: "16px",
  },
  shareFab: {
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
    position: "fixed",
    bottom: theme.spacing(2),
    left: theme.spacing(2),
  },
  shareFabMobile: {
    [theme.breakpoints.down("md")]: {
      display: "flex",
    },
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
    zIndex: "10",
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  spaceTools: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      marginTop: "40px",
    },
    [theme.breakpoints.up("sm")]: {
      marginTop: 0,
      marginLeft: "auto",
    },
  },
  viewButton: { height: "34px", borderRadius: "17px" },
  viewButtonTemp: { height: "34px", borderRadius: "17px", marginTop: 10 },
  iconButton: {
    margin: "0 4px",
  },
  iconButtonRoot: {
    display: "flex",
    background: "#ffffff",
    padding: theme.spacing(1),
    "&:hover": {
      color: "#ffffff",
      backgroundColor: "#6E54F4",
    },
  },
  unlistedIcon: {
    margin: "8px 12px",
  },
  editButton: { color: "#A9BDF1", margin: "auto 5px" },
  popPaper: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "rgba(0, 0, 0, 0)",
    border: "none",
    boxShadow: "none",
  },
}));

//#region SVG Icons
function BlenderIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M12.4683 13.1208C12.5093 12.3817 12.8687 11.7305 13.4108 11.269C13.9425 10.8157 14.658 10.5385 15.4388 10.5385C16.2188 10.5385 16.9343 10.8157 17.4664 11.269C18.0081 11.7305 18.3672 12.3817 18.409 13.1201C18.45 13.8795 18.1472 14.5851 17.6155 15.1079C17.0734 15.6397 16.3023 15.9736 15.4392 15.9736C14.5756 15.9736 13.8031 15.6397 13.2617 15.1079C12.7293 14.5851 12.4269 13.8795 12.4683 13.1208ZM7.73823 14.6144C7.74345 14.9036 7.8348 15.4658 7.97239 15.9045C8.26098 16.8336 8.75091 17.6928 9.43211 18.4503C10.1312 19.2289 10.9925 19.8542 11.9869 20.2981C13.0324 20.7645 14.1648 21.0019 15.3415 21C16.516 20.9985 17.6487 20.7563 18.6942 20.2864C19.6886 19.838 20.5492 19.2101 21.2471 18.4312C21.928 17.6707 22.4172 16.8095 22.7065 15.8804C22.8519 15.411 22.944 14.9348 22.9809 14.4567C23.0171 13.9857 23.0018 13.514 22.9354 13.0427C22.8057 12.1241 22.4902 11.2626 22.0044 10.4769C21.56 9.75511 20.9873 9.12305 20.3064 8.59127L20.3079 8.59014L13.4355 3.27491C13.4291 3.2704 13.4243 3.26514 13.4176 3.26101C12.9664 2.91212 12.2084 2.91325 11.7125 3.26289C11.211 3.61629 11.1536 4.20065 11.5999 4.56907L11.598 4.57095L14.4645 6.91854L5.72817 6.92793C5.72407 6.92793 5.7196 6.92793 5.71661 6.92793C4.99439 6.92868 4.30014 7.40602 4.16293 8.00916C4.02161 8.62357 4.51229 9.13319 5.26285 9.13582L5.26173 9.13845L9.68976 9.12981L1.78784 15.2393C1.77777 15.2469 1.76696 15.2547 1.75764 15.2619C1.0123 15.8369 0.771065 16.7926 1.24086 17.3977C1.71737 18.0128 2.73042 18.0139 3.48358 17.401L7.79603 13.846C7.79603 13.8464 7.73339 14.3264 7.73823 14.6144ZM18.8199 16.2214C17.9313 17.1333 16.6871 17.6504 15.3411 17.653C13.9932 17.6553 12.749 17.143 11.8605 16.2327C11.4261 15.7892 11.1073 15.2788 10.9105 14.735C10.7177 14.2006 10.6428 13.6335 10.6924 13.0615C10.7393 12.5023 10.9045 11.9686 11.1685 11.486C11.4276 11.0117 11.7848 10.5828 12.2255 10.2201C13.0894 9.511 14.189 9.12718 15.3393 9.12568C16.4906 9.12418 17.5894 9.50424 18.4541 10.211C18.8941 10.5723 19.2509 10.9993 19.51 11.4729C19.7751 11.9551 19.9392 12.4869 19.988 13.0476C20.0369 13.6192 19.9619 14.1852 19.7691 14.72C19.5719 15.2653 19.2542 15.776 18.8199 16.2214Z" />
    </SvgIcon>
  );
}

function UnityIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M18.2132 17.6438L14.7144 11.7527L18.2132 5.85977L19.9033 11.7527L18.2132 17.6438ZM10.4146 17.0781L6.01423 12.7082H13.0099L16.5069 18.6011L10.4146 17.0781ZM10.4146 6.42374L16.5087 4.90066L13.0099 10.7936H6.01423L10.4146 6.42374ZM19.3681 2L11.4025 4.07626L10.2242 6.09865L7.83186 6.08069L2 11.7527L7.83006 17.4229L10.2206 17.4049L11.4025 19.4273L19.3663 21.5036L21.5 13.7607L20.2876 11.7545L21.5 9.74827L19.3681 2Z" />
    </SvgIcon>
  );
}
//#endregion

const StyleChip = withStyles({
  root: {
    backgroundColor: "secondary",
  },
})(Chip);

const StyledMenu = withStyles({
  paper: {
    // border: '1px solid #d3d4d5',
    backgroundColor: "#222343",
    border: "solid 1px #393384",
    borderRadius: "8px",
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    // '&:focus': {
    //   backgroundColor: theme.palette.primary.main,
    //   '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
    //     color: theme.palette.common.white,
    //   },
    // },
  },
}))(MenuItem);

export default function SpacePage(props) {
  //#region Functions
  // #region Setup ******************************************

  const classes = useStyles();
  let params = useParams();
  let history = useHistory();

  const { bindKeys, unbindKeys, registerKeys } = useKeys();

  let {
    deleteSpace,
    setSpaceProperties,
    getSpaceInfo,
    setUserRole,
    getPermissions,
    addTags,
    removeTags,
    listNodes,
    getClientStatus,
    setClientStatus,
    listComments,
  } = useSpace();

  const {
    addSnack,
    addErrorSnack,
    addSuccessSnack,
    addInfoSnack,
  } = useSnackbar();

  const [spaceCreator, setSpaceCreator] = React.useState("");
  const [collaborators, setCollaborators] = React.useState([]);
  // const [inviteEmail, setInviteEmail] = React.useState("");

  const spaceRef = {
    studioId: props.studioId,
    projectId: props.projectId,
    spaceId: params.spaceId,
  };

  const refreshCollaborators = () => {
    getPermissions(spaceRef).then((res) => {
      //console.log("getpermissions")
      //console.log(res.toObject())
      const collaborators = res.toObject().collaboratorsList;
      //console.log(collaborators)
      setCollaborators(collaborators == null ? [] : collaborators);
    });
  };
  //#endregion

  //#region Viewers ----------------------------------------------------------
  const [activeClients, setActiveClients] = React.useState([]);
  const [unityViews, setUnityViews] = React.useState(0);
  const [blenderViews, setBlenderViews] = React.useState(0);
  const [webViews, setWebViews] = React.useState(0);
  //#endregion

  //#region Heartbeat ----------------------------------------------------------
  const clientHeartbeat = () => {
    const path = window.location.pathname;
    if (path == "/s/" + params.spaceId) {
      setClientStatus(spaceRef)
        .then(() => {
          // console.log(".");
        })
        .catch((err) => {
          console.error(err);
        });

      getClientStatus(spaceRef)
        .then((res) => {
          const response = res.toObject();
          setActiveClients(response.clientsList);
          let counts = { web: 0, unity: 0, blender: 0 };
          response.clientsList.forEach((clientInfo) => {
            let tokens = clientInfo.clientid.split("|");
            let clientType = tokens[0];
            if (clientType in counts) counts[clientType]++;
          });
          setWebViews(counts.web);
          setUnityViews(counts.unity);
          setBlenderViews(counts.blender);
        })
        .catch((err) => {
          console.error(err);
        });
      setTimeout(clientHeartbeat, 5000);
    }
  };

  React.useEffect(() => {
    clientHeartbeat();
  }, []);
  //#endregion

  //#region Space Description
  const [spaceNameHover, setSpaceNameHover] = React.useState([false]);

  const handleSpaceNameHover = () => {
    setSpaceNameHover(true);
  };

  const handleSpaceNameExit = () => {
    setSpaceNameHover(false);
  };
  //#endregion

  // #region Badges ******************************************
  const [numberOfNodes, setNumberOfNodes] = React.useState(0);
  const [numberOfViews, setNumberOfViews] = React.useState(0);
  const [numberOfComments, setNumberOfComments] = React.useState(0);

  const getBadgeData = () => {
    listNodes(spaceInfo).then((res) => {
      setNumberOfNodes(res.getNodesList().length);
    });
    getClientStatus(spaceInfo).then((res) => {
      setNumberOfViews(res.toObject().clientsList.length);
    });
    listComments(spaceInfo).then((comments) => {
      setNumberOfComments(comments.length);
    });
  };

  React.useEffect(() => {
    const abortController = new AbortController();
    getBadgeData();
    handleSpaceNameExit();

    return function cleanup() {
      abortController.abort();
    };
  }, []);
  //#endregion

  //#region Admin Privilege
  const privateTag = "mslsPrivate2020";

  function contains(target, pattern) {
    var value = 0;
    pattern.forEach(function (tag) {
      value = value + target.includes(tag);
    });
    return value === 1;
  }

  const adminIds = [
    "106034262800491206199", //Jonn Hanks
    "105771750488056444269", //Sonny Hughes
    "104169180763542771861", //Dom Hosler
    "105623008971318972097", //Richard Casemore
    "116890817960623956723", //Veronika Nesheva
    "105178160826864838769", //Jack Cohen
    "101300247124551126858", //Jacob Hilton
    "106279760294000821586", // Andy Schuhler
    "5f0dbce3580a1d9af4044e86",
  ];
  //#endregion

  // #region Analytics ******************************************
  const { metadata, profile } = useAuth();

  const userId = profile.sub.split("|")[1];

  React.useEffect(() => {
    if (profile == null) {
      trackUser("space-view-signed-out");
      return;
    }
    trackUser("space-view-signed-in", profile);
  }, [profile]);
  //#endregion

  // #region Delete Space ******************************************
  const [openDeleteDialog, setOpenDeleteSpaceDialog] = React.useState(false);

  const deleteSpaceClicked = (projectInfo) => {
    setOpenDeleteSpaceDialog(true);
  };

  const handleDeleteDialogClose = () => {
    setOpenDeleteSpaceDialog(false);
  };

  const executeDeleteSpace = () => {
    deleteSpace(spaceRef)
      .then((response) => {
        setOpenDeleteSpaceDialog(false);
        // TODO: Snackbar should exist with nav bar
        addSnack({
          severity: "success",
          message: "Space has been deleted",
        });
        // Navigate to Project View
        history.replace("/");
      })
      .catch((err) => {
        console.error(err);
        addSnack({
          severity: "error",
          message: "Could not delete Space",
        });
        setOpenDeleteSpaceDialog(false);
      });
  };
  //#endregion

  // #region Tags ******************************************
  const [openTagsDialog, setOpenTagsDialog] = React.useState(false);

  const [spaceTags, setSpaceTags] = React.useState([]);

  const [spaceTagsInput, setSpaceTagsInput] = React.useState("");

  function tagsKeyPress(e) {
    if (e.keyCode == 13 || e.keyCode == 188 || e.keyCode == 32) {
      updateTagsClicked();
    }
  }

  function setTagsDialogOpen(state) {
    setOpenTagsDialog(state);
    if (state) {
      unbindKeys();
    } else {
      bindKeys();
    }
  }

  // const addTagsClicked = () => {
  //   setTagsDialogOpen(true);
  // };

  const handleChipDelete = (tagToDelete) => (event) => {
    console.info("You clicked the delete icon.");

    let allTagsProps = {
      ...spaceRef,
      tags: [...spaceTags],
    };

    let tagToRemoveProps = {
      ...spaceRef,
      tags: [tagToDelete],
    };

    removeTags(tagToRemoveProps)
      .then((response) => {
        // Update the tags on the page
        setSpaceTags(allTagsProps.tags.filter((e) => e !== tagToDelete));
        addSnack({
          severity: "success",
          message: "Tag has been deleted",
        });
      })
      .catch((err) => {
        console.error(err);
        addSnack({
          severity: "error",
          message: "Could not delete Tag",
        });
      });
  };

  const handleChipClick = () => {
    console.info("You clicked the Chip.");
  };

  const updateTagsClicked = () => {
    let properties = {
      ...spaceRef,
      tags: [...spaceTags, spaceTagsInput],
    };
    addTags(properties)
      .then((res) => {
        console.log("received ");

        // Update the details on the page
        setSpaceTags(properties.tags);
        setSpaceTagsInput("");

        // Show snackbar
        addSnack({
          severity: "success",
          message: "Space tags updated",
        });
      })
      .catch((err) => {
        console.error(err);
        addSnack({
          severity: "error",
          message: "Could not update Space tags",
        });
      });
  };

  const spaceTagsInputChange = (e) => {
    setSpaceTagsInput(e.target.value);
    // setSpaceTags((prev) => (
    //   [...prev,
    //     e.target.value]
    // ));
  };

  // const [tagsFormOpen, setTagsFormOpen] = React.useState(false);
  //#endregion

  // #region File Upload ******************************************

  let dropRef = React.useRef(null);

  const [dropState, setDropState] = React.useState("Idle");

  const uploadFiles = (files) => {
    console.log("uploadFiles");
    console.log(files);
    console.log(files.length);
    console.log(files[0]);
    if (files.length == 1) {
      let url = process.env.REACT_APP_FBX_SERVICE;

      let formData = new FormData();
      formData.append("file", files[0]);
      formData.append("spaceId", spaceRef.spaceId);
      formData.append("projectId", spaceRef.projectId);
      formData.append("studioId", spaceRef.studioId);

      addSnack({
        severity: "info",
        message: "Uploading file...",
      });

      fetch(url, {
        headers: metadata,
        method: "POST",
        body: formData,
      })
        .then(() => {
          addSnack({
            severity: "success",
            message: "File uploded",
          });
        })
        .catch((err) => {
          addSnack({
            severity: "error",
            message: "Could not upload file",
          });
        });
    }
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDropState("Over");
  };
  const handleDragIn = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDropState("Enter");
  };
  const handleDragOut = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDropState("Leave");
  };
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDropState("Drop");
    uploadFiles(e.dataTransfer.files);
  };

  // React.useEffect(() => {
  //   if (dropRef) {
  //     let area = dropRef.current;
  //     area.addEventListener("dragenter", handleDragIn);
  //     area.addEventListener("dragleave", handleDragOut);
  //     area.addEventListener("dragover", handleDrag);
  //     area.addEventListener("drop", handleDrop);
  //   }
  //   return () => {
  //     if (dropRef) {
  //       let area = dropRef.current;
  //       area.removeEventListener("dragenter", handleDragIn);
  //       area.removeEventListener("dragleave", handleDragOut);
  //       area.removeEventListener("dragover", handleDrag);
  //       area.removeEventListener("drop", handleDrop);
  //     }
  //   };
  // }, []);

  //#endregion

  // #region Share Space ******************************************
  const [openShareDialog, setOpenShareDialog] = React.useState(false);

  const [emailChips, setEmailChips] = React.useState([]);

  const [emailChipsInput, setEmailChipsInput] = React.useState("");

  function shareKeyPress(e) {
    if (e.keyCode == 13 || e.keyCode == 188 || e.keyCode == 32) {
      updateEmailChipsClicked();
    }
  }

  function setShareDialogOpen(state) {
    setOpenShareDialog(state);
    if (state) {
      unbindKeys();
    } else {
      bindKeys();
    }
  }

  const handleEmailChipDelete = (emailToDelete) => (event) => {
    let currentEmailChips = emailChips;
    console.info("You deleted an email address");
    setEmailChips(currentEmailChips.filter((e) => e !== emailToDelete)); // will return ['A', 'C']
  };

  const handleEmailChipClick = () => {
    console.info("You clicked the Email Chip.");
  };

  const updateEmailChipsClicked = () => {
    if (
      emailChipsInput.length >= 6 &&
      emailChipsInput.includes("@") &&
      !emailChipsInput.includes(" ") &&
      !emailChipsInput.includes(",")
    ) {
      let newEmail = [...emailChips, emailChipsInput];
      setEmailChips(newEmail);
      setEmailChipsInput("");
    } else {
      addSnack({
        severity: "error",
        message: "This is not a valid email address",
      });
    }
  };

  const emailChipsInputChange = (e) => {
    if (e.target.value != " " && e.target.value != ",") {
      setEmailChipsInput(e.target.value);
    }
    // setSpaceTags((prev) => (
    //   [...prev,
    //     e.target.value]
    // ));
  };

  const sendEmailTo = (email) => {
    Services.sendShareEmailWithSnacks(setUserRole, spaceInfo, profile, email, {
      setShareDialogOpen: setShareDialogOpen,
      refreshCollaborators: refreshCollaborators,
      addSuccessSnack: addSuccessSnack,
      addErrorSnack: addErrorSnack,
      addInfoSnack: addInfoSnack,
    });
  };

  const shareSpaceInviteClicked = () => {
    if (emailChips.length < 1) {
      if (
        emailChipsInput.length >= 6 &&
        emailChipsInput.includes("@") &&
        !emailChipsInput.includes(" ") &&
        !emailChipsInput.includes(",")
      ) {
        sendEmailTo(emailChipsInput);
      } else {
        addSnack({
          severity: "error",
          message: "This is not a valid email address",
        });
      }
    } else {
      emailChips.map((email) => {
        sendEmailTo(email);
      });
    }
  };
  //#endregion

  // #region Update Space ******************************************
  const [spaceName, setSpaceName] = React.useState("");
  const [spaceDescription, setSpaceDescription] = React.useState("");
  const [spaceInfo, setSpaceInfo] = React.useState([]);

  const [spaceNameInput, setSpaceNameInput] = React.useState("");
  const [spaceDescriptionInput, setSpaceDescriptionInput] = React.useState("");

  const [editFormOpen, setEditFormOpen] = React.useState(false);

  function editSpaceKeyPress(e) {
    //Used to bind the enter key to update the form. Have turned this off for now as it may intefere with people entering descriptions
    // if (e.keyCode == 13) {
    //   updateSpaceClicked();
    // }
  }

  function setEditDialogOpen(state) {
    setEditFormOpen(state);
    setSpaceNameInput(spaceName);
    setSpaceDescriptionInput(spaceDescription);
    if (state) {
      unbindKeys();
    } else {
      bindKeys();
    }
  }

  const spaceTitleChange = (e) => {
    setSpaceNameInput(e.target.value);
  };

  const spaceDescriptionChange = (e) => {
    setSpaceDescriptionInput(e.target.value);
  };

  const updateSpaceClicked = () => {
    if (spaceNameInput == "") {
      addSnack({
        severity: "error",
        message: "Please enter a name for your space",
      });
      return;
    }
    let properties = {
      name: spaceNameInput,
      description: spaceDescriptionInput,
      tagsList: spaceTags,
      ...spaceRef,
    };

    setSpaceName(spaceNameInput);
    setSpaceDescription(spaceDescriptionInput);

    setEditDialogOpen(false);
    setSpaceProperties(properties)
      .then((res) => {
        console.log("received ");
        //console.log(projectInfo);

        // Update the details on the page
        setSpaceName(res.getProperties().getName());
        console.log(res.getProperties().getName());
        setSpaceNameInput(res.getProperties().getName());
        setSpaceDescription(res.getProperties().getDescription());
        console.log(res.getProperties().getDescription());
        setSpaceDescriptionInput(res.getProperties().getDescription());

        // Show snackbar
        addSnack({
          severity: "success",
          message: "Space details updated",
        });
      })
      .catch((err) => {
        console.error(err);
        addSnack({
          severity: "error",
          message: "Could not update Space details",
        });
      });
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  //#endregion

  // #region Copy Space ******************************************
  const copySpaceClicked = () => {
    let link = process.env.REACT_APP_ROOT + "/s/" + spaceRef.spaceId;
    navigator.clipboard.writeText(link).then(
      () => {
        /* clipboard successfully set */
        addSnack({
          severity: "success",
          message: "Space link copied to clipboard!",
        });
        setTimeout(() => {
          addSnack({
            severity: "info",
            message: "Paste into Unity or Blender to connect",
          });
        }, 4000);
      },
      () => {
        /* clipboard error */
        addSnack({
          severity: "error",
          message: "Could not copy link to clipboard",
        });
      }
    );
  };
  //#endregion

  // #region Command Bar ******************************************
  const { registerCommands, unregisterCommands } = useCommands();

  const commands = [
    {
      id: "share-space",
      name: "Share Space",
      description: "Invite others to collaborate",
      shortcut: "",
      command: () => {
        setShareDialogOpen(true);
      },
    },
    {
      id: "edit-space",
      name: "Edit Space",
      description: "Change Space title & description",
      shortcut: "",
      command: () => {
        setEditDialogOpen(true);
      },
    },
    {
      id: "copy-space-link",
      name: "Copy Space Link",
      description: "Copy the Space link to the clipboard",
      shortcut: "",
      command: () => {
        copySpaceClicked();
      },
    },
    {
      id: "edit-tags",
      name: "Edit Tags",
      description: "Change Space Tags",
      shortcut: "",
      command: () => {
        setTagsDialogOpen(true);
      },
    },
  ];

  const addCommands = () => {
    registerCommands(commands);
  };

  const removeCommands = () => {
    unregisterCommands(commands);
  };
  //#endregion

  // #region List Space ******************************************
  React.useEffect(() => {
    /** Mount ******************************************/
    // Get space info on load
    getSpaceInfo(spaceRef).then(async (remoteSpaceInfo) => {
      // console.log("spaceInfo");
      // console.log(remoteSpaceInfo);
      let description = remoteSpaceInfo.properties.description;
      if (description == "") {
        description = "This Space doesn't have a description :(";
      }
      let newSpaceInfo = remoteSpaceInfo;
      newSpaceInfo.projectId = spaceRef.projectId;
      newSpaceInfo.studioId = spaceRef.studioId;
      newSpaceInfo.spaceId = spaceRef.spaceId;
      setSpaceInfo(remoteSpaceInfo);
      setSpaceName(remoteSpaceInfo.properties.name);
      setSpaceDescription(description);
      setSpaceTags(remoteSpaceInfo.tagsList);
      setSpaceCreator(
        await Services.getUserProfile(remoteSpaceInfo.createmetadata.userid)
      );
    });
    // Get collaborator info
    refreshCollaborators();
    // Add commands to command bar
    addCommands();
    /** Unmount ******************************************/
    return () => {
      removeCommands();
    };
  }, []);
  //#endregion

  //#region Profile Popover
  const [viewsAnchorEl, setViewsAnchorEl] = React.useState(null);

  const handleViewsClick = (event) => {
    setViewsAnchorEl(event.currentTarget);
  };

  const handleViewsClose = () => {
    setViewsAnchorEl(null);
  };

  const viewsOpen = Boolean(viewsAnchorEl);
  const id = viewsOpen ? "views-popover" : undefined;
  //#endregion
  //#endregion

  return (
    <>
      <MetaTags>
        <title>
          {"Massless Space | " +
            (spaceName == "" ? "Untitled Space" : spaceName)}
        </title>
        <meta
          name="description"
          content={
            spaceName == ""
              ? "Massless Space. Multi-user real-time collaboration across Unity, Blender and Chrome"
              : spaceDescription
          }
        />
        <meta
          property="og:title"
          content={
            "Massless Space | " +
            (spaceName == "" ? "Untitled Space" : spaceName)
          }
        />
        <meta
          property="og:image"
          content={`https://storage.googleapis.com/massless-space-content/Spaces/${spaceRef.spaceId}/thumbnail.png`}
        />
      </MetaTags>
      <Box className={classes.appBody}>
        <Box className={classes.spaceTopUI}>
          <Hidden smDown>
            <Tooltip title="Total Viewers" placement="right">
              <Button
                className={classes.viewButton}
                variant="outlined"
                color="primary"
                startIcon={<VisibilityIcon />}
                onClick={handleViewsClick}
                // disabled
              >
                {webViews + unityViews + blenderViews}
              </Button>
            </Tooltip>
            <Popover
              classes={{ root: classes.popover, paper: classes.popPaper }}
              id={id}
              open={viewsOpen}
              anchorEl={viewsAnchorEl}
              onClose={handleViewsClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
            >
              <Tooltip title="Web Viewers" placement="right">
                <Button
                  className={classes.viewButtonTemp}
                  variant="outlined"
                  color="primary"
                  startIcon={<WebIcon />}
                  // disabled
                >
                  {webViews}
                </Button>
              </Tooltip>
              <Tooltip title="Blender Viewers" placement="right">
                <Button
                  className={classes.viewButtonTemp}
                  variant="outlined"
                  color="primary"
                  startIcon={<BlenderIcon />}
                  // disabled
                >
                  {blenderViews}
                </Button>
              </Tooltip>
              <Tooltip title="Unity Viewers" placement="right">
                <Button
                  className={classes.viewButtonTemp}
                  variant="outlined"
                  color="primary"
                  startIcon={<UnityIcon />}
                  // disabled
                >
                  {unityViews}
                </Button>
              </Tooltip>
            </Popover>
          </Hidden>
          <Box className={classes.spaceDetails}>
            <Box display="flex" maxWidth="100%">
              <Typography
                onMouseEnter={handleSpaceNameHover}
                onMouseLeave={handleSpaceNameExit}
                className={classes.pageTitle}
              >
                {spaceName}
              </Typography>
              <Tooltip
                classes={{ tooltip: classes.toolTip }}
                title="Edit Space Details"
              >
                <IconButton
                  // color="text.primary"
                  size="small"
                  className={classes.editButton}
                  // classes={{ root: classes.iconButtonRoot }}
                  aria-label="edit space details"
                  onClick={() => {
                    trackUser(
                      "space-view-edit-clicked",
                      profile,
                      props.spaceInfo
                    );
                    setEditDialogOpen(true);
                  }}
                  // style={{ marginLeft: "4px", marginRight: "4px" }}
                >
                  <EditIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
            <Hidden smDown>
              {spaceNameHover && (
                <Typography className={classes.pageDescriptionDesktop}>
                  {spaceDescription}
                </Typography>
              )}
            </Hidden>
            {/* <Hidden smUp>
              <Typography className={classes.pageDescriptionMobile}>
                {spaceDescription}
              </Typography>
            </Hidden> */}
          </Box>
          <Box className={classes.spaceTools}>
            <Tooltip
              classes={{ tooltip: classes.toolTip }}
              title="Only visible to people with the link"
            >
              <UnlistedIcon className={classes.unlistedIcon} />
            </Tooltip>
            <Tooltip
              classes={{ tooltip: classes.toolTip }}
              title="Copy Link to Clipboard"
            >
              <IconButton
                className={classes.iconButton}
                classes={{ root: classes.iconButtonRoot }}
                aria-label="copy link to clipboard"
                onClick={() => {
                  trackUser(
                    "space-page-copy-space-clicked",
                    profile,
                    props.spaceInfo
                  );
                  copySpaceClicked(props.spaceInfo);
                }}
              >
                <LinkIcon />
              </IconButton>
            </Tooltip>
            <Tooltip classes={{ tooltip: classes.toolTip }} title="Add Tags">
              <IconButton
                className={classes.iconButton}
                classes={{ root: classes.iconButtonRoot }}
                aria-label="add tags"
                onClick={() => {
                  trackUser(
                    "space-view-add-tags-clicked",
                    profile,
                    props.spaceInfo
                  );
                  setTagsDialogOpen(true);
                }}
                // style={{ marginLeft: "4px", marginRight: "4px" }}
              >
                <TagIcon />
              </IconButton>
            </Tooltip>
            <Tooltip classes={{ tooltip: classes.toolTip }} title="Share Space">
              <IconButton
                className={classes.iconButton}
                classes={{ root: classes.iconButtonRoot }}
                aria-label="share space"
                onClick={() => {
                  trackUser(
                    "space-page-share-space-clicked",
                    profile,
                    props.spaceInfo
                  );
                  setShareDialogOpen(true);
                }}
              >
                <SendIcon />
              </IconButton>
            </Tooltip>
            <Tooltip
              classes={{ tooltip: classes.toolTip }}
              title={"This space was created by " + spaceCreator.nickname}
            >
              <IconButton
                variant="outlined"
                size="small"
                className={classes.iconButton}
                classes={{ root: classes.iconButtonRoot }}
                aria-label="edit space details"
                // style={{ marginLeft: "4px", marginRight: "8px" }}
              >
                <Avatar
                  alt="User Avatar"
                  className={classes.userAvatar}
                  src={(spaceCreator && spaceCreator.picture) || ""}
                  //component={Link}
                  //to={"/account"}
                  //onClick={() => {
                  // trackUser("nav-avatar-click");
                  //}}
                  style={{
                    width: "24px",
                    height: "24px",
                  }}
                />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
        {/******************************   SPACE VIEWER  ****************************/}
        <SpaceViewer spaceInfo={spaceRef} />
        {/* <SpaceInspector spaceInfo={spaceRef} /> */}
      </Box>
      {/* *********************** SHARE SPACE DIALOG **************************** */}
      <Dialog
        classes={{ paper: classes.shareDialog }}
        open={openShareDialog}
        onClose={() => {
          setShareDialogOpen(false);
        }}
      >
        <DialogTitle id="form-dialog-title">Share your Space</DialogTitle>
        <DialogContent style={{ padding: "8px" }}>
          <DialogContentText style={{ padding: "0 16px" }}>
            Invite your friends or colleages to collaborate on your Space.
          </DialogContentText>
          <DialogContentText
            style={{ padding: "0 16px", marginBottom: "16px" }}
          >
            Enter their email addresses below seperated with spaces or commas.
          </DialogContentText>
          <Box className={classes.emailField}>
            <TextField
              value={emailChipsInput}
              onKeyDown={shareKeyPress}
              onChange={emailChipsInputChange}
              autoFocus
              id="title"
              label="Emails"
              type="text"
              fullWidth
              color="primary"
            />
            <Tooltip
              classes={{ tooltip: classes.toolTip }}
              title="Add Email Address"
            >
              <IconButton
                style={{ margin: "0 8px" }}
                size="small"
                onClick={() => {
                  updateEmailChipsClicked();
                }}
              >
                <AddIcon />
              </IconButton>
            </Tooltip>
          </Box>
          <Box className={classes.chipList} component="ul">
            {emailChips.map((email) => {
              return (
                <li>
                  <StyleChip
                    size="small"
                    className={classes.chip}
                    label={email}
                    onClick={handleEmailChipClick}
                    onDelete={handleEmailChipDelete(email)}
                    color="primary"
                    deleteIcon={
                      <Tooltip
                        classes={{ tooltip: classes.toolTip }}
                        title="Delete this email address!"
                      >
                        <DeleteIcon />
                      </Tooltip>
                    }
                  />
                </li>
              );
            })}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              trackUser("share-project-form-cancel-click", profile, {
                studioId: params.studioId,
                projectId: params.projectId,
              });
              setShareDialogOpen(false);
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={async () => {
              trackUser("share-project-form-invite-click", profile, {
                studioId: params.studioId,
                projectId: params.projectId,
              });
              shareSpaceInviteClicked();
            }}
            color="primary"
          >
            Share
          </Button>
        </DialogActions>
      </Dialog>
      {/* *********************** EDIT SPACE DIALOG **************************** */}
      <Dialog
        open={editFormOpen}
        onClose={() => {
          setEditDialogOpen(false);
        }}
      >
        <DialogTitle id="form-dialog-title">Edit your Space</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Update the space information below
          </DialogContentText>
          <TextField
            value={spaceNameInput}
            onChange={spaceTitleChange}
            onKeyDown={editSpaceKeyPress}
            autoFocus
            margin="dense"
            id="title"
            label="Title"
            type="text"
            fullWidth
            color="primary"
          />
          <TextField
            value={spaceDescriptionInput}
            onChange={spaceDescriptionChange}
            onKeyDown={editSpaceKeyPress}
            margin="dense"
            id="description"
            label="Description"
            type="text"
            fullWidth
            multiline
            rows={3}
            color="primary"
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              trackUser("edit-form-cancel-click", profile, {
                studioId: params.studioId,
                projectId: params.projectId,
              });
              setEditDialogOpen(false);
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={async () => {
              trackUser("edit-form-update-click", profile, {
                studioId: params.studioId,
                projectId: params.projectId,
              });
              updateSpaceClicked();
            }}
            color="primary"
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
      {/* *********************** SPACE TAGS DIALOG **************************** */}
      <Dialog
        open={openTagsDialog}
        onClose={() => {
          setTagsDialogOpen(false);
        }}
      >
        <DialogTitle id="form-dialog-title">Add your tags</DialogTitle>
        <DialogContent className={classes.tagDialog}>
          <DialogContentText style={{ padding: "0 16px" }}>
            Enter your tag below
          </DialogContentText>
          <Box className={classes.emailField}>
            <TextField
              value={spaceTagsInput}
              onKeyDown={tagsKeyPress}
              color="primary"
              onChange={spaceTagsInputChange}
              autoFocus
              margin="dense"
              id="title"
              label="Title"
              type="text"
              fullWidth
            />
          </Box>
          <Box className={classes.chipList} component="ul">
            {spaceTags
              .filter((e) => e != privateTag)
              .map((tag) => {
                return (
                  <li>
                    <StyleChip
                      size="small"
                      className={classes.chip}
                      label={tag}
                      onClick={handleChipClick}
                      onDelete={handleChipDelete(tag)}
                      color="primary"
                      deleteIcon={
                        <Tooltip
                          classes={{ tooltip: classes.toolTip }}
                          title="Delete this tag!"
                        >
                          <DeleteIcon />
                        </Tooltip>
                      }
                    />
                  </li>
                );
              })}
            {contains(userId, adminIds) &&
              spaceTags
                .filter((e) => e == privateTag)
                .map((tag) => {
                  return (
                    <>
                      <Box className={classes.privateChipList} component="ul">
                        <Typography style={{ marginTop: "16px" }}>
                          Private Tag
                        </Typography>
                        <li>
                          <StyleChip
                            size="small"
                            className={classes.chip}
                            label={tag}
                            onClick={handleChipClick}
                            onDelete={handleChipDelete(tag)}
                            color="primary"
                            deleteIcon={
                              <Tooltip
                                classes={{ tooltip: classes.toolTip }}
                                title="Delete this tag!"
                              >
                                <DeleteIcon />
                              </Tooltip>
                            }
                          />
                        </li>
                      </Box>
                    </>
                  );
                })}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              trackUser("edit-tags-cancel-click", profile, {
                studioId: params.studioId,
                projectId: params.projectId,
              });
              setTagsDialogOpen(false);
            }}
            color="text.primary"
          >
            Cancel
          </Button>
          <Button
            type="Submit"
            onClick={async () => {
              trackUser("edit-tags-update-click", profile, {
                studioId: params.studioId,
                projectId: params.projectId,
              });
              updateTagsClicked();
            }}
            color="primary"
          >
            Add Tag
          </Button>
        </DialogActions>
      </Dialog>
      {/* *********************** CONFIRM DELETE DIALOG **************************** */}
      <Dialog
        open={openDeleteDialog}
        onClose={handleDeleteDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Are you sure you want to delete this Space?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Deleting this Space will remove it from the Global Studio
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteDialogClose} color="text.primary">
            Don't Delete
          </Button>
          <Button onClick={executeDeleteSpace} color="secondary" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

{
  /* <Grid container className={classes.bodyContainer} ref={dropRef}>
        <Grid item xs={12} sm={6} md={6} className={classes.pageDetails}>
          <Typography className={classes.pageTitle}>{spaceName}</Typography>
          <Box
            style={{ fontWeight: "300" }}
            className={classes.pageDescription}
          >
            {spaceDescription}
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={6} className={classes.spaceTools}>
          {contains(spaceTags, [privateTag]) && (
            <Tooltip
              classes={{ tooltip: classes.toolTip }}
              title="Only visible to people with the link"
            >
              <UnlistedIcon className={classes.unlistedIcon} />
            </Tooltip>
          )}
          <Tooltip
            classes={{ tooltip: classes.toolTip }}
            title="Copy Link to Clipboard"
          >
            <IconButton
              className={classes.iconButton}
              classes={{ root: classes.iconButtonRoot }}
              aria-label="copy link to clipboard"
              onClick={() => {
                trackUser(
                  "space-page-copy-space-clicked",
                  profile,
                  props.spaceInfo
                );
                copySpaceClicked(props.spaceInfo);
              }}
              // style={{ marginLeft: "4px", marginRight: "4px" }}
            >
              <LinkIcon />
            </IconButton>
          </Tooltip>
          <Tooltip classes={{ tooltip: classes.toolTip }} title="Share Space">
            <IconButton
              className={classes.iconButton}
              classes={{ root: classes.iconButtonRoot }}
              aria-label="share space"
              onClick={() => {
                trackUser(
                  "space-page-share-space-clicked",
                  profile,
                  props.spaceInfo
                );
                setShareDialogOpen(true);
              }}
            >
              <SendIcon />
            </IconButton>
          </Tooltip>
          <Tooltip classes={{ tooltip: classes.toolTip }} title="Add Tags">
            <IconButton
              className={classes.iconButton}
              classes={{ root: classes.iconButtonRoot }}
              aria-label="add tags"
              onClick={() => {
                trackUser(
                  "space-view-add-tags-clicked",
                  profile,
                  props.spaceInfo
                );
                setTagsDialogOpen(true);
              }}
              // style={{ marginLeft: "4px", marginRight: "4px" }}
            >
              <TagIcon />
            </IconButton>
          </Tooltip>
          <Tooltip
            classes={{ tooltip: classes.toolTip }}
            title="Edit Space Details"
          >
            <IconButton
              variant="outlined"
              // color="primary"
              size="small"
              className={classes.iconButton}
              classes={{ root: classes.iconButtonRoot }}
              aria-label="edit space details"
              onClick={() => {
                trackUser("space-view-edit-clicked", profile, props.spaceInfo);
                setEditDialogOpen(true);
              }}
              // style={{ marginLeft: "4px", marginRight: "4px" }}
            >
              <EditIcon />
            </IconButton>
          </Tooltip>
          <Tooltip
            classes={{ tooltip: classes.toolTip }}
            title={"This space was created by " + spaceCreator.nickname}
          >
            <IconButton
              variant="outlined"
              size="small"
              className={classes.iconButton}
              classes={{ root: classes.iconButtonRoot }}
              aria-label="edit space details"
              // style={{ marginLeft: "4px", marginRight: "8px" }}
            >
              <Avatar
                alt="User Avatar"
                className={classes.userAvatar}
                src={(spaceCreator && spaceCreator.picture) || ""}
                //component={Link}
                //to={"/account"}
                //onClick={() => {
                // trackUser("nav-avatar-click");
                //}}
                style={{
                  width: "24px",
                  height: "24px",
                }}
              />
            </IconButton>
          </Tooltip>
          {/* <Tooltip
                  classes={{ tooltip: classes.toolTip }}
                  title={
                    collaborators.length > 0 ? (
                      <>
                        {collaborators.map((email) => {
                          return <p>{email}</p>;
                        })}
                      </>
                    ) : (
                      <Typography>No collaborators</Typography>
                    )
                  }
                >
                  <IconButton
                    className={classes.iconButton}
                    aria-label="Collaborators"
                    onClick={() => {
                      trackUser(
                        "space-page-collaborators-clicked",
                        props.spaceInfo
                      );
                      //copySpaceClicked(props.spaceInfo);
                    }}
                  >
                    <Badge badgeContent={collaborators.length} color="secondary">
                      <FaceIcon />
                    </Badge>
                  </IconButton>
                </Tooltip> 
                <Box
                  
                  id="drop-area"
                  style={{
                    width: "50px",
                    height: "50px",
                    background: "white",
                    color: "black",
                  }}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  {dropState}
                </Box> */
}
{
  /* <Tooltip
                  classes={{ tooltip: classes.toolTip }}
                  title="Space Actions"
                >
                  <IconButton
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={(e) => {
                      trackUser(
                        "space-page-space-menu-click",
                        profile,
                        props.spaceInfo
                      );
                      handleClick(e);
                    }}
                    style={{ marginLeft: "4px", marginRight: "8px" }}
                  >
                    <MoreVertIcon />
                  </IconButton>
                </Tooltip>
                <StyledMenu
                  id="customized-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                > */
}
{
  /* <StyledMenuItem
                      onClick={() => {
                        trackUser("space-view-edit-clicked", spaceInfo);
                        setEditFormOpen(true);
                        handleClose();
                      }}
                    >
                      <ListItemIcon>
                        <LinkIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText primary="Copy URL" />
                    </StyledMenuItem> 
                    <Divider />*/
}
{
  /* <StyledMenuItem
                    onClick={() => {
                      trackUser("space-view-edit-clicked", profile, spaceInfo);
                      setEditDialogOpen(true);
                      handleClose();
                    }}
                  >
                    <ListItemIcon>
                      <EditIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Edit Details" />
                  </StyledMenuItem>
                  <Divider />
                  <StyledMenuItem
                    onClick={() => {
                      trackUser("share-space-clicked", profile, spaceInfo);
                      setShareDialogOpen(true);
                      handleClose();
                    }}
                  >
                    <ListItemIcon>
                      <SendIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Share Space" />
                  </StyledMenuItem> */
}
{
  /*<Divider />
                  <StyledMenuItem
                    onClick={() => {
                      trackUser("delete-space-clicked", profile, spaceInfo);
                      deleteSpaceClicked();
                      handleClose();
                    }}
                  >
                    <ListItemIcon>
                      <DeleteIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Delete Space" />
                  </StyledMenuItem>*/
}
{
  /* <Divider />
                  <StyledMenuItem
                    onClick={() => {
                      trackUser("add-tags-clicked", profile, spaceInfo);
                      setTagsDialogOpen(true);
                      handleClose();
                    }}
                  >
                    <ListItemIcon>
                      <TagIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Add Tags" />
                  </StyledMenuItem>
                </StyledMenu> */
}
{
  /* </Grid> */
}
{
  /* </Grid> */
}
{
  /* </Box> */
}
{
  /* </Grid> */
}
